/**
 * 获取浏览器的兼容性
 */
class BrowserSupport {
    constructor() {
        this.s = {
            video: this.ifSupportVideo(),
            MSE: this.ifSupportMse(),
            websocket: this.ifSupportSocket(),
            getUserMedeia: this.ifSupportUserMedia(),
            connection: this.ifSupportConnection(),
            candidate: this.ifSupportCandidate(),
            session: this.ifSupportSession(),
        };
    }
    get() {
        return this.s;
    }
    /**
     * 是否支持video
     */
    ifSupportVideo() {
        let videoElement = document.createElement('video');
        if (videoElement && videoElement.canPlayType) {
            return true; // 是否支持video属性
        }
        return false;
    }
    /**
     * 是否支持MSE
     */
    ifSupportMse() {
        let mse = window['MediaSource'] || window['WebKitMediaSource'];
        if (mse && mse.isTypeSupported) {
            return true;
        }
        return false;
    }
    /**
     * 是否支持socket
     */
    ifSupportSocket() {
        if (window.WebSocket) {
            return true; // 是否支持websocket
        }
        return false;
    }
    /**
     * 是否支持获取媒体属性
     */
    ifSupportUserMedia() {
        if (navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia) {
            return true;
        }
        return false;
    }
    /**
     * 是否支持webrtc的connect
     */
    ifSupportConnection() {
        if (
            window.RTCPeerConnection ||
            window.mozRTCPeerConnection ||
            window.webkitRTCPeerConnection ||
            window.PeerConnection ||
            window.webkitPeerConnection00
        ) {
            return true;
        }
        return false;
    }
    /**
     * 是否支持candidate
     */
    ifSupportCandidate() {
        if (window.RTCIceCandidate || window.mozRTCIceCandidate || window.webkitRTCSessionDescription) {
            return true;
        }
        return false;
    }
    /**
     * 是否支持webrct的session
     */
    ifSupportSession() {
        if (window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitRTCSessionDescription) {
            return true;
        }
        return false;
    }
}
export default BrowserSupport;



// WEBPACK FOOTER //
// ./components/FPlayer-component-utils/browserSupport.js